export const earnings = {
  earningsTitle: "Earnings",

  // Summary
  totalEarnings: "Total Earnings",
  paid: "Paid",
  pending: "Pending",
  dueToday: "Due Today",
  searchEarningsPlaceholderKey: "Order (#PO/Project)",

  // Filters

  invoiceDate: "Invoice Date",
  status: "Status",
  clearFilters: "Clear",
  downloadCSV: "Download CSV",
  submitInvoice: "Submit Invoice Request",
  poDate: "PO Creation Date",

  // Table
  poHeader: "PO",
  invoiceHeader: "Invoice",
  statusHeader: "Status",
  skillHeader: "Skill",
  volumeHeader: "Volume",
  unitRate: "unit Rate",
  penaltyHeader: "Penalty",
  amountHeader: "Amount",
  poValue: "PO Value",
  loadingEarnings: "Loading earnings...",
  emptyEarnings: "You don't have any earnings yet",
  totalEarningsInfo: "Includes requested and paid amounts.",
  poValueInfo: "Payment will only be made once the payment term days lapse",

  submitInvoiceRequest: "Submit Invoice Request",
  note: "Note",
  writeHere: "Write here...",

  downloadCsv: "Download CSV",
};
